<template>
	<div class="menu-wp">
		<div class="container">
			<div class="menu-dl">
				<div class="menu-line"></div>
				<dl>
					<dd v-for="(item,index) in menuChilds" :key="index" 
					:class="{ cur : item.id == curIDprop }"  @click="navTo(item,index)"
					:id='`dd-${item.id}`'  @mouseenter="dd_fun(item.id,index)"
					>
					{{item.name}}
					</dd>
				</dl>
				<div class="clear"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'hmenu',
		props: ['menuID','curID'],
		data(){
			return{
				menuIDprop :'',
				curIDprop:0,
				menuChilds:[],
			}
		},
		methods:{
			res_menuChild(e){
				this.axios.get('/api/menus/parentNumber?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.menuChilds = response.data.reslut;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			dd_fun(e,p){
				let id = `dd-${e}`;
				let dom = $(`#${id}`);
				$('.menu-line').stop().animate({
					'left': p*130
				}, 200, 'linear')
			},
			navTo(item,index){
				if(this.curIDprop == item.id){
					return
				}else{
					this.curIDprop = item.id;
					this.$emit('son-btn', { sondata: this.curIDprop })
				}
				
				//特殊页面跳转
				/*
					资质展示:/aptitude;
					联系我们:/contactus;
					列表类:/elist
					特殊列表(一三九通讯):/communication;
					专家库:/specialist
					招聘:/join
					分支机构:/branch
					
				*/
				if(item.name == '资质展示'){
					this.$router.push({
						path:'/slider/'+ this.menuIDprop + '/aptitude',
						query:{
							category_id:item.id
						}
					})
				}
				if(item.name == '联系我们'){
					this.$router.push({
						path:'/slider/'+ this.menuIDprop + '/contactus',
						query:{
							category_id:item.id
						}
					})
				}
				if(item.name == '专家库'){
					this.$router.push({
						path:'/slider/'+ this.menuIDprop + '/specialist',
						query:{
							category_id:item.id
						}
					})
				}
				if(item.name == '人才招聘'){
					this.$router.push({
						path:'/slider/'+ this.menuIDprop + '/join',
						query:{
							category_id:item.id
						}
					})
				}
				if(item.name == '一三九通讯'){
					this.$router.push({
						path:'/slider/'+ this.menuIDprop + '/communication',
						query:{
							category_id:item.id
						}
					})
				}
				if(item.name == '公司新闻' || item.name == '地勘成果' || item.name == '公司荣誉' || item.name == '文化动态'){
					this.$router.push({
						path:'/slider/'+ this.menuIDprop + '/elist',
						query:{
							category_id:item.id
						}
					})
				}
				if(item.name == '公司简介' || item.name == '企业文化' || item.name == '组织架构' || item.name == '领导集体' || item.name == '地质勘查' || item.name == '测绘工作' || item.name == '地质灾害预防' || item.name == '新能源开发'){
					this.$router.push({
						path:'/slider/'+ this.menuIDprop + '/single',
						query:{
							category_id:item.id
						}
					})
				}
				
				
			}
		},
		created(){
			this.menuIDprop = this.menuID;
			this.curIDprop = this.curID;
			this.$emit('son-btn', { sondata: this.curIDprop })
			this.res_menuChild(this.menuIDprop)
		},
		watch :{
			'menuID' (to, from) {
					// 对路由变化作出响应...
					// console.log("to",to)
					// console.log("from",from)
					this.menuChilds = []
					this.menuIDprop = to;
					// this.curIDprop = 1000;
					this.res_menuChild(this.menuIDprop);
					$('.menu-line').stop().animate({
						'left': 0
					}, 0, 'linear')
					// this.$emit('son-btn', { sondata: this.menuChilds[0].id })
			},
			'curID' (to, from) {
					// 对路由变化作出响应...
					this.curIDprop = Number(to);
			}
		},
	}
</script>

<style>
</style>